import AudioManager from "../../../../../manager/audio_manager";

export default class K9Sound {
    static path:string = 'package/k9/sound/';

    //背景音乐
    static playBg(){
        AudioManager.instance.playMusic(K9Sound.path + 'bgm/K9', false);
    }

    //暂停音乐
    static stopSound(audioID:number){
        cc.audioEngine.stop(audioID);
    }
    
    static playSound(name:string){
        AudioManager.instance.playSound(K9Sound.path + name, false, null)
    }

    static playClock(){
        K9Sound.playSound('djs');
    }

    static playWin(){
        K9Sound.playSound('win');
    }

    static playLose(){
        K9Sound.playSound('lose');
    }

    static playT8T9(){
        K9Sound.playSound('tian89')
    }

  
}
